module.exports = __webpack_public_path__ + "img/logo-small.5e7512c7.png";